export const REIMBURSEMENTTYPE_LOADING = "REIMBURSEMENTTYPE_LOADING";
export const REIMBURSEMENTTYPE_RESET = "REIMBURSEMENTTYPE_RESET";
export const GET_REIMBURSEMENTTYPE = "GET_REIMBURSEMENTTYPE";
export const GET_REIMBURSEMENTTYPE_SUCCESS = "GET_REIMBURSEMENTTYPE_SUCCESS";
export const GET_REIMBURSEMENTTYPE_FAIL = "GET_REIMBURSEMENTTYPE_FAIL";
export const DELETE_REIMBURSEMENTTYPE = "DELETE_REIMBURSEMENTTYPE"
export const DELETE_REIMBURSEMENTTYPE_SUCCESS = "DELETE_REIMBURSEMENTTYPE_SUCCESS"
export const DELETE_REIMBURSEMENTTYPE_FAIL = "DELETE_REIMBURSEMENTTYPE_FAIL"
export const UPDATE_REIMBURSEMENTTYPE = "UPDATE_REIMBURSEMENTTYPE"
export const UPDATE_REIMBURSEMENTTYPE_SUCCESS = "UPDATE_REIMBURSEMENTTYPE_SUCCESS"
export const UPDATE_REIMBURSEMENTTYPE_FAIL = "UPDATE_REIMBURSEMENTTYPE_FAIL"
export const ADD_NEW_REIMBURSEMENTTYPE = "ADD_NEW_REIMBURSEMENTTYPE"
export const ADD_REIMBURSEMENTTYPE_SUCCESS = "ADD_REIMBURSEMENTTYPE_SUCCESS"
export const ADD_REIMBURSEMENTTYPE_FAIL = "ADD_REIMBURSEMENTTYPE_FAIL"